/* eslint-env browser */
const mosaycWorker = new Worker('scripts/worker-mosayc.js')
const resizeMosaycWorker = new Worker('scripts/worker-resize.js')

const body = document.querySelector('body')
const insertTarget = document.querySelector('.light-container')

let content = document.querySelector('#main')
let loading = content ? content.querySelector('.loading') : null

let containerWidth = content.getBoundingClientRect().width
let containerPadding = containerWidth - content.clientWidth


let resizeNewContent

const updateMosayc = () => {
  content = document.querySelector('#main')
  loading = content ? content.querySelector('.loading') : null

  containerWidth = content.getBoundingClientRect().width
  containerPadding = containerWidth - content.clientWidth
}

function mosayc(all, fotos, inject = false) {
  const contContentWidth = containerWidth - containerPadding

  const steps = Math.floor(contContentWidth / 500)

  const sizes = fotos.map(val => [parseInt(val.getAttribute('width'), 10), parseInt(val.getAttribute('height'), 10)])

  const aspec = fotos.map(val => parseInt(val.getAttribute('width'), 10) / parseInt(val.getAttribute('height'), 10))

  mosaycWorker.postMessage({
    contContentWidth,
    steps,
    sizes,
    aspec,
  })
  mosaycWorker.onmessage = event => {
    const endSizes = event.data
    const finalMosayc = document.createDocumentFragment()
    all.forEach((item, index) => {
      const target = item.querySelector('img')
      target.style.width = endSizes[index].width
      target.style.height = endSizes[index].height
      finalMosayc.appendChild(item)
    })
    if (inject) {
      fastdom.mutate(() => {
        loading.classList.add('--pause')
        content.insertBefore(finalMosayc, loading)

        getLazyElements(true) // eslint-disable-line no-undef

      })
    } else {
      resizeMosaycWorker.postMessage('')
      resizeNewContent = finalMosayc
    }
  }
}
let newContent
const resizeMosayc = () => {
  updateMosayc()
  const oldContent = content.cloneNode(true)
  const all = Array.prototype.slice.call(oldContent.querySelectorAll('.card-foto'))
  const foto = Array.prototype.slice.call(oldContent.querySelectorAll('img'))
  const loadings = Array.prototype.slice.call(oldContent.querySelectorAll('.loading'))
  newContent = document.createDocumentFragment()
  const main = document.createElement('main')
  main.classList.add('content')
  main.setAttribute('id', 'main')
  newContent.appendChild(main)
  mosayc(all, foto)
  resizeMosaycWorker.onmessage = () => {
    const target = newContent.querySelector('main')
    if (target) {
      const newMosayc = resizeNewContent
      loadings.forEach(item => newMosayc.appendChild(item))

      target.appendChild(newMosayc)

      content.remove()

      body.insertBefore(newContent, insertTarget)
    }

    updateMosayc()

    getLazyElements(true) // eslint-disable-line no-undef
  }
}

window.addEventListener('resize', () => setTimeout(resizeMosayc, 100), false)
